/**
 * Check Email Route
 *
 * Integrates with existing CheckEmailPage component from Story 1.3.
 * Displays after registration to prompt user to verify email.
 */

import { createFileRoute } from "@tanstack/react-router";
import { CheckEmailPage } from "../../pages/auth/CheckEmail";

export const Route = createFileRoute("/_auth/check-email")({
  component: CheckEmailRoute,
});

function CheckEmailRoute() {
  // Email would typically come from registration state or URL params
  // For now, use a placeholder - will be enhanced with state management
  return <CheckEmailPage apiBaseUrl="" />;
}
